// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.rep-thumb {
  position: absolute;
  top: 50%;
  transform: translate(-50%, -50%) scale(1.2);
  display: flex;
  justify-content: center;
  align-items: center;
  width: 48px;
  height: 48px;
  border: 3px solid;
  border-radius: 50%;
  background-color: #458bea;
  overflow: visible;
  box-shadow: 0 0 10px var(--glow-color);
  cursor: pointer;
  z-index: 100;
  transition: all 0.3s ease;
}

.rep-thumb:hover {
  transform: translate(-50%, -60%) scale(1.3);
  box-shadow: 0 5px 15px var(--glow-color);
}

.rep-thumb img {
  width: 100%;
  height: 100%;
  object-fit: cover;
  object-position: center;
  border-radius: 50%;
}

.rep-thumb .tooltip {
  visibility: hidden;
  width: 150px;
  background-color: rgba(0, 0, 0, 0.8);
  color: #fff;
  text-align: center;
  border-radius: 6px;
  padding: 10px;
  position: absolute;
  z-index: 1000;
  bottom: 120%;
  left: 50%;
  transform: translateX(-50%);
  opacity: 0;
  transition: opacity 0.3s, visibility 0.3s;
  pointer-events: none;
}

.rep-thumb:hover .tooltip {
  visibility: visible;
  opacity: 1;
}

.rep-thumb .tooltip::after {
  content: '';
  position: absolute;
  top: 100%;
  left: 50%;
  margin-left: -5px;
  border-width: 5px;
  border-style: solid;
  border-color: rgba(0, 0, 0, 0.8) transparent transparent transparent;
}

.rep-thumb .tooltip strong {
  display: block;
  margin-bottom: 5px;
}

.rep-thumb .tooltip p {
  margin: 3px 0;
  font-size: 12px;
}

.rep-thumb.grayed-out {
  opacity: 0.5;
}

@media (max-width: 768px) {
  .rep-thumb {
    width: 36px;
    height: 36px;
  }
  
  .rep-thumb .tooltip {
    width: 120px;
    font-size: 10px;
  }
}
`, "",{"version":3,"sources":["webpack://./src/components/RepThumb/RepThumb.css"],"names":[],"mappings":"AAAA;EACE,kBAAkB;EAClB,QAAQ;EACR,2CAA2C;EAC3C,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,WAAW;EACX,YAAY;EACZ,iBAAiB;EACjB,kBAAkB;EAClB,yBAAyB;EACzB,iBAAiB;EACjB,sCAAsC;EACtC,eAAe;EACf,YAAY;EACZ,yBAAyB;AAC3B;;AAEA;EACE,2CAA2C;EAC3C,wCAAwC;AAC1C;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,iBAAiB;EACjB,uBAAuB;EACvB,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,YAAY;EACZ,oCAAoC;EACpC,WAAW;EACX,kBAAkB;EAClB,kBAAkB;EAClB,aAAa;EACb,kBAAkB;EAClB,aAAa;EACb,YAAY;EACZ,SAAS;EACT,2BAA2B;EAC3B,UAAU;EACV,yCAAyC;EACzC,oBAAoB;AACtB;;AAEA;EACE,mBAAmB;EACnB,UAAU;AACZ;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,SAAS;EACT,SAAS;EACT,iBAAiB;EACjB,iBAAiB;EACjB,mBAAmB;EACnB,oEAAoE;AACtE;;AAEA;EACE,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,eAAe;AACjB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE;IACE,WAAW;IACX,YAAY;EACd;;EAEA;IACE,YAAY;IACZ,eAAe;EACjB;AACF","sourcesContent":[".rep-thumb {\n  position: absolute;\n  top: 50%;\n  transform: translate(-50%, -50%) scale(1.2);\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  width: 48px;\n  height: 48px;\n  border: 3px solid;\n  border-radius: 50%;\n  background-color: #458bea;\n  overflow: visible;\n  box-shadow: 0 0 10px var(--glow-color);\n  cursor: pointer;\n  z-index: 100;\n  transition: all 0.3s ease;\n}\n\n.rep-thumb:hover {\n  transform: translate(-50%, -60%) scale(1.3);\n  box-shadow: 0 5px 15px var(--glow-color);\n}\n\n.rep-thumb img {\n  width: 100%;\n  height: 100%;\n  object-fit: cover;\n  object-position: center;\n  border-radius: 50%;\n}\n\n.rep-thumb .tooltip {\n  visibility: hidden;\n  width: 150px;\n  background-color: rgba(0, 0, 0, 0.8);\n  color: #fff;\n  text-align: center;\n  border-radius: 6px;\n  padding: 10px;\n  position: absolute;\n  z-index: 1000;\n  bottom: 120%;\n  left: 50%;\n  transform: translateX(-50%);\n  opacity: 0;\n  transition: opacity 0.3s, visibility 0.3s;\n  pointer-events: none;\n}\n\n.rep-thumb:hover .tooltip {\n  visibility: visible;\n  opacity: 1;\n}\n\n.rep-thumb .tooltip::after {\n  content: '';\n  position: absolute;\n  top: 100%;\n  left: 50%;\n  margin-left: -5px;\n  border-width: 5px;\n  border-style: solid;\n  border-color: rgba(0, 0, 0, 0.8) transparent transparent transparent;\n}\n\n.rep-thumb .tooltip strong {\n  display: block;\n  margin-bottom: 5px;\n}\n\n.rep-thumb .tooltip p {\n  margin: 3px 0;\n  font-size: 12px;\n}\n\n.rep-thumb.grayed-out {\n  opacity: 0.5;\n}\n\n@media (max-width: 768px) {\n  .rep-thumb {\n    width: 36px;\n    height: 36px;\n  }\n  \n  .rep-thumb .tooltip {\n    width: 120px;\n    font-size: 10px;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
